export default __webpack_public_path__ + "static/crv-9e93069bd9c6b80d442934e9ad572403.png";